// extracted by mini-css-extract-plugin
module.exports = {"addProductIcon":"EmptyShelfContent_addProductIcon__2h9t7"};